import { makeStyles, tokens } from "@fluentui/react-components";

export const useAgendaStyle = makeStyles({
	customAgendaHeader: {
		margin: "40px 10px 14px 10px",
		fontSize: "24px",
		color: tokens.colorNeutralForeground1,
	},
	customEvent: {
		backgroundColor: tokens.colorNeutralBackground1,
		boder: "2px transparent",
		boxShadow: "rgba(0, 0, 0, .092))",
		margin: "0px 10px 14px 10px",
		padding: "0px",
		display: "flex",
		borderRadius: "8px",
	},
	userAgendaPopupContent: {
		padding: "1vh",
		height: "70vh",
		overflowY: "scroll",
	},
	agendaContentContainer: {
		backgroundColor: tokens.colorNeutralBackground2,
		width: "100%",
	},
	agendaCloseButton: {
		position: "absolute",
		right: "33px",
		float: "right",
		top: "16px",
		cursor: "pointer",
	},
	noAgendaFound: {
		position: "absolute",
		left: "50%",
		top: "50%",
		transform: "translate(-50%, -50%)",
		fontSize: "4vh",
	},
	eventTimeContainer: {
		display: "flex",
		flexDirection: "column",
		margin: "18px 38px 18px 18px",
		width: "125px",
	},
	eventTime: {
		fontSize: "12px",
		color: tokens.colorNeutralForeground1,
		fontWeight: tokens.fontWeightSemibold,
	},
	eventDetailsContainer: {
		listStyleType: "none",
		padding: "0px",
		margin: "0px",
		fontStyle: "normal",
		fontWeight: tokens.fontWeightRegular,
	},
	eventSubject: {
		margin: "0px 18px 0px 0px",
		fontSize: "19px",
		color: tokens.colorNeutralForeground1,
	},
	centerVertically: {
		marginTop: "15px",
	},
	eventLocationContainer: {
		display: "flex",
		margin: "0px 18px 0px 0px",
	},
	eventLocationIcon: {
		height: "12px",
	},
	eventLocation: {
		fontSize: "12px",
		color: tokens.colorNeutralForeground1,
		margin: "0px 0px 0px 4px",
		lineHeight: "17px",
	},
	fullWidth: {
		width: "90%",
	},
});
